import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SettlementTermReferenceService extends BaseReferenceService {
  constructor() {
    super('SettlementTermReference');
  }
}
